module.exports = __webpack_public_path__ + "img/1.0bfbf8e9.png";